// src/mobile/sub-navigation.ts
import { EventManager, setupEventListenersIfNeeded } from './event-manager';
import { SubNavigationItem } from './types';
import { postJsMessage } from '../../../bridge';
import API from '../../../api';

export function setSubNavigationConfig(config: {
  showSubNavigation: boolean;
  items: SubNavigationItem[];
}): Promise<any> {
  const processedItems = config.items.map((item) => {
    if (item.onTap) {
      EventManager.getInstance().registerCallback(
        'onSubNavigationItemClick',
        item.actionID,
        item.onTap
      );
    }
    return { ...item, onTap: undefined };
  });

  return postJsMessage(API.setSubNavigationConfig, {
    ...config,
    items: processedItems,
  });
}

export function updateSubNavigationItem(
  actionID: string,
  update: Partial<SubNavigationItem>
): Promise<any> {
  setupEventListenersIfNeeded();
  // Cleanup old callback
  EventManager.getInstance().unregisterCallback(
    'onSubNavigationItemClick',
    actionID
  );

  if (update.onTap) {
    EventManager.getInstance().registerCallback(
      'onSubNavigationItemClick',
      actionID,
      update.onTap
    );
  }

  return postJsMessage(API.updateSubNavigationItem, {
    actionID,
    update: { ...update, onTap: undefined },
  });
}

export function setSelectedSubNavigationItem(actionID: string): Promise<any> {
  setupEventListenersIfNeeded();
  return postJsMessage(API.setSelectedSubNavigationItem, { actionID });
}
